<template>
      <search-from
        :fields="fields"
        :pagination="pagination"
        @click="onSearch"
      ></search-from>
</template>
<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {Membership} from "../../models/Membership"
    import {parseEnum} from "../../shared/utils";
    import {PaginationMeta} from "../../models/PaginationMeta";
    import SearchFrom from "../base/SearchForm";
    import {SearchField} from "../../services/SearchField";

    const MembershipRepo = RepositoryFactory.get('membership')

    export default {
      name: 'membership-search-form',
      components: {
        SearchFrom,
      },
      props: {
        pagination: Object,
        default: new PaginationMeta(),
      },
      data() {
          return {
              fields: [
                new SearchField()
                  .setLabel('ID')
                  .setDescription('Membership ID')
                  .setIsAdvanced(true)
                  .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
                  .setKey('id')
                ,
                new SearchField()
                  .setLabel('Type')
                  .setDescription('Membership Type')
                  .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
                  .setValues(parseEnum(Membership.TYPES))
                  .setKey('type')
                ,
                new SearchField()
                  .setLabel('Status')
                  .setDescription('Membership Status')
                  .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
                  .setValues(parseEnum(Membership.STATUS))
                  .setKey('status')
                ,
                new SearchField()
                  .setLabel('Person Name')
                  .setDescription('Person Name')
                  .setIsAdvanced(true)
                  .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
                  .setKey('personName')
                ,
                new SearchField()
                  .setLabel('Person Surname')
                  .setDescription('Person Surname')
                  .setIsAdvanced(true)
                  .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
                  .setKey('personSurname')
                ,
                new SearchField()
                  .setLabel('Person Email')
                  .setDescription('Person Email')
                  .setIsAdvanced(true)
                  .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
                  .setKey('personEmail')
                ,
              ],
          }
      },
      methods: {
          onSearch(params) {
            this.$emit('clicked', params)
            MembershipRepo
              .searchMembership(params)
              .then(
                response => (
                  this.$emit('change', response.data)
                )
              )
          },
      },
    }
</script>
